import { render, staticRenderFns } from "./delLogSon.vue?vue&type=template&id=4346a9bb&scoped=true&"
import script from "./delLogSon.vue?vue&type=script&lang=js&"
export * from "./delLogSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4346a9bb",
  null
  
)

export default component.exports